import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getSolutionFromProblemMappedTo } from '../../../../functions/get_solution_to';
import '../../../solution_screen/solution_implimentation/solution_imp.css';

export default function WizardSolutionImplementationForm({ eventData, problemData, solutionData, onDataChange, initialData }) {
    const [solutionImages, setSolutionImages] = useState([]);
    const solutionHowToSliderRef = useRef();

    useEffect(() => {
        // Get solution images from problem mapped to
        if (problemData?.pickedPMT && eventData?.eventType) {
            const images = getSolutionFromProblemMappedTo(problemData.pickedPMT, eventData.eventType);
            setSolutionImages(images);

            // Notify parent of solution implementation data
            if (onDataChange) {
                onDataChange({
                    solutionImages: images
                });
            }
        }
    }, [problemData?.pickedPMT, eventData?.eventType, onDataChange]);

    const settingsSlick = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    // Get principle deficiency display text
    const getPrincipleDeficiencyText = () => {
        if (!problemData?.pickedPD || problemData.pickedPD.length === 0) return '';
        return problemData.pickedPD.join(', ');
    };

    // Get problem mapped to display text
    const getProblemMappedToText = () => {
        if (!problemData?.pickedPMT || problemData.pickedPMT.length === 0) return '';
        return problemData.pickedPMT.join(', ');
    };

    // Get solution mapped to display text
    const getSolutionMappedToText = () => {
        if (!solutionData?.solutionMappedTo || solutionData.solutionMappedTo.length === 0) return '';
        return solutionData.solutionMappedTo.join(', ');
    };

    return (
        <div className="wizard-solution-implementation-form">
            <div className='solution-view-container'>
                <div className='solution-details-panel'>
                    <div className='detail-field'>
                        <label className='detail-label'>Event Name</label>
                        <div className='detail-value'>{eventData?.eventName || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Negative Function Executed</label>
                        <div className='detail-value negative'>{eventData?.negative || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Problem Identified from Event</label>
                        <div className='detail-value negative'>{eventData?.problem || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Principle Deficiency</label>
                        <div className='detail-value'>
                            {getPrincipleDeficiencyText()}
                        </div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Problem Mapped to</label>
                        <div className='detail-value'>
                            {getProblemMappedToText()}
                        </div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Solution Mapped</label>
                        <div className='detail-value'>
                            {getSolutionMappedToText()}
                        </div>
                    </div>
                </div>

                <div className='solution-images-panel'>
                    <div className="images">
                        <h1 className='title'>Solution How To</h1>
                        {solutionImages.length > 0 ? (
                            <Slider ref={solutionHowToSliderRef} className='carasoul-box' {...settingsSlick}>
                                {solutionImages.map((image, index) => (
                                    <div key={index} className="carousel-slide">
                                        <img alt={`Solution How To ${index + 1}`} src={image} className="solution-image" />
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            <div className="no-images-message">
                                <p>No solution images available</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

// Export validation function (solution implementation step is read-only, so always valid)
export const validateSolutionImplementationForm = () => {
    return { valid: true };
};
